import {FC} from 'react'
import {FallbackProps} from 'react-error-boundary'

const ErrorFallback: FC<FallbackProps> = ({error, resetErrorBoundary}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        inset: 0,
        position: 'fixed',
      }}
    >
      <div
        style={{
          padding: 24,
          backgroundColor: 'white',
          borderRadius: 32,
          maxWidth: 500,
        }}
      >
        <h2
          style={{
            fontSize: 30,
          }}
        >
          Noe gikk galt... 😱
        </h2>
        <p
          style={{
            marginTop: 16,
            fontSize: 18,
            fontWeight: 'normal',
            fontFamily: 'sans-serif',
          }}
        >
          {error.message
            ? error.message
            : 'Vi vet ikke helt hva som skjedde, men feilen er logget og vi jobber med å fikse det.'}
        </p>
        <div
          style={{
            marginTop: 16,
          }}
        >
          <button
            style={{
              marginTop: 16,
              padding: '8px 16px',
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: 8,
              fontSize: 20,
              pointerEvents: 'auto',
            }}
            onClick={resetErrorBoundary}
          >
            Prøv igjen
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback
